<script setup>
import { onBeforeMount, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

const body = document.getElementsByTagName("body")[0];

const store = useStore();
const toggleDefaultLayout = () => store.commit("toggleDefaultLayout");


onBeforeMount(() => {
  store.state.hideConfigButton = true;
  toggleDefaultLayout();
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  toggleDefaultLayout();
  body.classList.add("bg-gray-100");
});

</script>
<template>
  <main class="mt-0 main-content card-detail-layout">
    <section>
      <div
class="page-header min-vh-100" :style="{
        backgroundImage: 'url(' + '/img/logos/public-back-ground.png' + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }">
        <span class="mask bg-primary opacity-3"></span>
        <div class="container text-center">
          <div class="row justify-content-md-center mb-6">
            <div class="w-50">
              <img class="img-fluid" src="/img/logos/beedelivery_logo.png" alt="logo" />
            </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card">
                <div class="card-header text-center">
                  <h3 class="font-weight-bolder">Solicitud enviada</h3>
                  <p >
                    Hemos enviado un correo con las instrucciones para completar el cambio de contrasena. Revise su bandeja de entrada y siga los pasos indicados.
                  </p>
                </div>
                <div class="card-body">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </section>
  </main>
</template>
